import { render, staticRenderFns } from "./DashboardPranesimai.vue?vue&type=template&id=8b0b9262&scoped=true&"
import script from "./DashboardPranesimai.vue?vue&type=script&lang=js&"
export * from "./DashboardPranesimai.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPranesimai.vue?vue&type=style&index=0&id=8b0b9262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0b9262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VContainer,VDataTable,VTooltip})
